"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addFalconSSWidgets = void 0;
var FalconSSCancellationSuccessWidget_1 = require("./FalconSSCancellationSuccessWidget");
var FalconSSCRefundOutputWidget_1 = require("./FalconSSCRefundOutputWidget");
var FalconSSCancellationSuccessPopupWidget_1 = require("./FalconSSCancellationSuccessPopupWidget");
var AddressChangeDeclineTextOutputWidget_1 = require("./AddressChangeDeclineTextOutputWidget");
var AddressChangePriceOutputWidget_1 = require("./AddressChangePriceOutputWidget");
var ChangePaymentDayPriceOutputWidget_1 = require("./ChangePaymentDayPriceOutputWidget");
var CurrentCoverPriceWidget_1 = require("./CurrentCoverPriceWidget");
var OvernightLocationTextWidget_1 = require("./OvernightLocationTextWidget");
var OvernightLocationHeaderPanelWidget_1 = require("./OvernightLocationHeaderPanelWidget");
var addFalconSSWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "falconSSCancellationSuccess",
        component: FalconSSCancellationSuccessWidget_1.FalconSSCancellationSuccessWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "falconSSRefundOutput",
        component: FalconSSCRefundOutputWidget_1.FalconSSCRefundOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "falconSSRefundPopup",
        component: FalconSSCancellationSuccessPopupWidget_1.FalconSSCancellationSuccessPopupWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "addressChangeDeclineTextOutput",
        component: AddressChangeDeclineTextOutputWidget_1.AddressChangeDeclineTextOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "addressChangePriceOutput",
        component: AddressChangePriceOutputWidget_1.AddressChangePriceOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "changePaymentDayPriceOutputWidget",
        component: ChangePaymentDayPriceOutputWidget_1.ChangePaymentDayPriceOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "currentCoverWidget",
        component: CurrentCoverPriceWidget_1.CurrentCoverPriceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "overnightLocationText",
        component: OvernightLocationTextWidget_1.OvernightLocationTextWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "overnightLocationHeaderPanel",
        component: OvernightLocationHeaderPanelWidget_1.OvernightLocationHeaderPanelWidget
    });
};
exports.addFalconSSWidgets = addFalconSSWidgets;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/falconSelfService/index.js
// module id = 3264
// module chunks = 0